export default __webpack_public_path__ + "static/media/upload.7ed7525b.svg";